/**
 * Created by mac on 2/25/20
 */

const ChestListTemplates = {
    heroItems: function (type, config) {
        return {
            hero: type,
            noHeroes: {
                coins: config
            },
            ...config 
        };
    },

    extendResourceChest: function (type, stages) {
        return stages.map((config) => {
            config = { ...config };
            config[type] = config.resource;
            delete config.resource;
            return config;
        });
    }
};
    
const SourceChestBonues = [{
    heroitem: {
        hero: "hero",
        basic: [0, 0, 0],
        bonus: [1, 1],
        itemsProb: [0.58, 0.29, 0.13],
        prob: 0.5,
        noHeroes: {
            coins: {
                basic: [0, 0, 0],
                bonus: [1, 1],
                itemsProb: [0.58, 0.29, 0.13],
                prob: 0.5
            }
        }
    },
    fruit: {
        family: true,
        basic: [0],
        bonus: [1, 1],
        prob: 0.5
    }
}, {
    coins: {
        basic: [0],
        bonus: [2, 2],
        prob: 0.3
    },
    worker: {
        basic: [0],
        bonus: [1, 1],
        prob: 0.2
    },
    heroitem: {
        hero: "hero",
        basic: [0, 0, 0],
        bonus: [2, 2],
        itemsProb: [0.58, 0.29, 0.13],
        prob: 0.8,
        noHeroes: {
            coins: {
                basic: [1, 0, 0],
                bonus: [2, 2],
                itemsProb: [0.58, 0.29, 0.13],
                prob: 0.8
            }
        }
    },
    fruit: {
        family: true,
        basic: [0, -1, -1, -1, 0],
        bonus: [1, 3]
    }
}, {
    rubies: {
        basic: [0],
        bonus: [2, 2],
        prob: 0.3
    },
    coins: {
        basic: [0],
        bonus: [2, 2],
        prob: 0.3
    },
    crystal: {
        basic: [0],
        bonus: [2, 2],
        prob: 0.3
    },
    worker: {
        basic: [0],
        bonus: [0, 1]
    },
    heroitem: {
        hero: "hero",
        basic: [0, 0, 0],
        bonus: [2, 2],
        itemsProb: [0.58, 0.29, 0.13],
        prob: 0.8,
        noHeroes: {
            coins: {
                basic: [1, 0, 0],
                bonus: [2, 2],
                itemsProb: [0.58, 0.29, 0.13],
                prob: 0.8
            }
        }
    },
    fruit: {
        family: true,
        basic: [0, -1, -1, -1, 0],
        bonus: [2, 4]
    }
}];

const ChestListPrize = {
    treasure: [{
        rubies: {
            basic: [0, 0],
            bonus: [2, 3]
        },
        coins: {
            basic: [0, 0],
            bonus: [1, 2]
        }
    }, {
        rubies: {
            basic: [0, 1],
            bonus: [1, 2]
        },
        coins: {
            basic: [0, 2, 0],
            bonus: [2, 3]
        }
    }, {
        rubies: {
            basic: [0, 1, 0],
            bonus: [2, 3]
        },
        coins: {
            basic: [0, 2, 1],
            bonus: [4, 5]
        },
        crystal: {
            basic: [1],
            bonus: [0, 1]
        }
    }],

    freechest: [{
        fruit: {
            family: true,
            basic: [1, -1, -1, -1, 0],
            bonus: [1, 1],
            itemsProb: [0.85, 0, 0, 0, 0.15],
            prob: 0.3
        },
        coins: {
            basic: [0, 0],
            bonus: [2, 2],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        },
        worker: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.2
        },
        heroitem: {
            hero: "hero",
            basic: [1, 0],
            bonus: [1, 1],
            itemsProb: [0.66, 0.34],
            prob: 0.8,
            noHeroes: {
                coins: {
                    basic: [2, 0],
                    bonus: [1, 1],
                    itemsProb: [0.66, 0.34],
                    prob: 0.8
                }
            }
        }
    }, {
        fruit: {
            family: true,
            basic: [2, 0, -1, -1, 0],
            bonus: [2, 2],
            itemsProb: [0.6, 0.3, 0, 0, 0.1],
            prob: 0.5
        },
        coins: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        },
        worker: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.5
        },
        heroitem: {
            hero: "hero",
            basic: [0, 1, 0],
            bonus: [2, 2],
            itemsProb: [0.6, 0.3, 0.1],
            prob: 0.75,
            noHeroes: {
                coins: {
                    basic: [2, 1, 0],
                    bonus: [2, 2],
                    itemsProb: [0.6, 0.3, 0.1],
                    prob: 0.75
                }
            }
        },
        crystal: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.4
        }
    }, {
        rubies: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.25
        },
        fruit: {
            family: true,
            basic: [0, 2, 0, -1, 0],
            bonus: [3, 3],
            itemsProb: [0.5, 0.25, 0.15, 0, 0.1],
            prob: 0.65
        },
        coins: {
            basic: [1, 1, 0],
            bonus: [4, 4],
            itemsProb: [0.6, 0.25, 0.15],
            prob: 0.55
        },
        worker: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.8, 0.2],
            prob: 0.5
        },
        heroitem: {
            hero: "hero",
            basic: [1, 0, 1],
            bonus: [2, 2],
            itemsProb: [0.6, 0.3, 0.1],
            prob: 0.75,
            noHeroes: {
                coins: {
                    basic: [4, 2, 1],
                    bonus: [2, 2],
                    itemsProb: [0.6, 0.3, 0.1],
                    prob: 0.75
                }
            }
        },
        crystal: {
            basic: [1, 0],
            bonus: [2, 2],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        }
    }],

    herochest: [{
        coins: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.8
        },
        worker: {
            basic: [0],
            bonus: [1, 2],
            prob: 0.3
        },
        heroitem: {
            hero: "hero",
            basic: [1, 0],
            bonus: [2, 4],
            prob: 0.6,
            noHeroes: {
                coins: {
                    basic: [2, 0],
                    bonus: [2, 4],
                    prob: 0.6
                }
            }
        }
    }, {
        coins: {
            basic: [1],
            bonus: [2, 2],
            prob: 0.8
        },
        worker: {
            basic: [0],
            bonus: [3, 3],
            prob: 0.3
        },
        heroitem: {
            hero: "hero",
            basic: [1, 1, 0],
            bonus: [3, 6],
            itemsProb: [0.25, 0.50, 0.25],
            prob: 0.6,
            noHeroes: {
                coins: {
                    basic: [3, 1, 0],
                    bonus: [3, 6],
                    itemsProb: [0.25, 0.50, 0.25],
                    prob: 0.6
                }
            }
        }
    }, {
        coins: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        },
        worker: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.66, 0.34],
            prob: 0.3
        },
        heroitem: {
            hero: "hero",
            basic: [1, 1, 1],
            bonus: [4, 6],
            itemsProb: [0.34, 0.33, 0.33],
            prob: 0.6,
            noHeroes: {
                coins: {
                    basic: [3, 2, 1],
                    bonus: [4, 6],
                    itemsProb: [0.34, 0.33, 0.33],
                    prob: 0.6
                }
            }
        }
    }],

    dailytaskchest: [{
        coins: {
            basic: [-1, 2, 0],
            bonus: [2, 2],
            itemsProb: [0, 0.66, 0.34],
            prob: 0.8
        },
        rubies: {
            basic: [-1, 1],
            bonus: [2, 2],
            prob: 0.6
        }
    }, {
        coins: {
            basic: [-1, 1, 1, 0],
            bonus: [4, 4],
            itemsProb: [0, 0.42, 0.42, 0.16],
            prob: 0.8
        },
        rubies: {
            basic: [-1, 1, 1],
            bonus: [3, 3],
            itemsProb: [0, 0.66, 0.34],
            prob: 0.6
        },
        worker: {
            basic: [1, 0],
            bonus: [2, 2],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        }
    }, {
        coins: {
            basic: [-1, 1, 1, 1],
            bonus: [5, 5],
            itemsProb: [0, 0.34, 0.33, 0.33],
            prob: 0.8
        },
        rubies: {
            basic: [-1, 1, 2],
            bonus: [4, 4],
            itemsProb: [0, 0.66, 0.34],
            prob: 0.6
        },
        worker: {
            basic: [1, 0],
            bonus: [2, 2],
            itemsProb: [0.66, 0.34],
            prob: 0.5
        },
        crystal: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.75, 0.25],
            prob: 0.5
        }
    }],

    woodchest: [
        {
            wood: {
                basic: [3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            wood: {
                basic: [1, 1],
                bonus: [2, 4],
                itemsProb: [0.6, 0.4],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            wood: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    stonechest: [
        {
            stone: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            stone: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            stone: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    wagonchest: [
        {
            wagon: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            wagon: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            wagon: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    bamboochest: [
        {
            bamboo: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            bamboo: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            bamboo: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    sapphirechest: [
        {
            sapphire: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            sapphire: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            sapphire: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    snowchest: [
        {
            snow: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            snow: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            snow: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    lavachest: [
        {
            lava: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            lava: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            lava: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    sandchest: [
        {
            sand: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            sand: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            sand: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    asiachest: [
        {
            asia: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            asia: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            asia: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    warcraftchest: [
        {
            warcraft: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            warcraft: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            warcraft: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    steampunkchest: [
        {
            steampunk: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            steampunk: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            steampunk: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    moonstonechest: [
        {
            moonstone: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0] 
        },

        {
            moonstone: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1] 
        },

        {
            moonstone: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2] 
        }
    ],

    sacks: [{
        fruit: {
            family: true,
            basic: [4, -1, -1, -1, 0],
            bonus: [0, 1]
        }
    }, {
        fruit: {
            family: true,
            basic: [7, -1, -1, -1, 1],
            bonus: [0, 2]
        }
    }, {
        fruit: {
            family: true,
            basic: [11, -1, -1, -1, 3],
            bonus: [0, 2]
        }
    }],

    drresourcechest: [{
        resource: {
            basic: [3],
            bonus: [1, 1],
            prob: 0.2
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [2, 1],
            bonus: [3, 3],
            itemsProb: [0.7, 0.3],
            prob: 0.55
        })
    }, {
        resource: {
            basic: [2, 2],
            bonus: [2, 2],
            itemsProb: [0.7, 0.3],
            prob: 0.4
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [3, 2, 1],
            bonus: [4, 4],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.6
        }),

        coins: {
            basic: [1, 0, 0],
            bonus: [2, 2],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.45
        }
    }, {
        resource: {
            basic: [1, 1, 2],
            bonus: [4, 4],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.55
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [0, 4, 4],
            bonus: [4, 4],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.6
        }),

        rubies: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.20
        },

        coins: {
            basic: [0, 1, 0],
            bonus: [2, 2],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.6
        }
    }],

    drshopchest: [{
        drresource: {
            family: true,
            basic: [3, 1],
            bonus: [2, 2],
            itemsProb: [0.85, 0.15],
            prob: 0.4
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [1, 3],
            bonus: [2, 2],
            itemsProb: [0.7, 0.3],
            prob: 0.45
        }),

        coins: {
            basic: [1, 0, 0],
            bonus: [2, 2],
            itemsProb: [0.6, 0.3, 0.1],
            prob: 0.5
        }
    }, {
        drresource: {
            family: true,
            basic: [0, 1, 2],
            bonus: [2, 2],
            itemsProb: [0.70, 0.25, 0.05],
            prob: 0.5
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [0, 2, 1],
            bonus: [2, 2],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.5
        }),

        coins: {
            basic: [2, 0],
            bonus: [2, 2],
            itemsProb: [0.7, 0.3],
            prob: 0.5
        },

        rubies: {
            basic: [1],
            bonus: [2, 2],
            prob: 0.35
        }
    }, {
        drresource: {
            family: true,
            basic: [0, 2, 4],
            bonus: [2, 2],
            itemsProb: [0.70, 0.25, 0.05],
            prob: 0.5
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [0, 2, 2],
            bonus: [3, 3],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.5
        }),

        coins: {
            basic: [2, 2, 0],
            bonus: [2, 2],
            itemsProb: [0.7, 0.25, 0.05],
            prob: 0.5
        },

        rubies: {
            basic: [1, 0],
            bonus: [2, 2],
            itemsProb: [0.9, 0.1],
            prob: 0.4
        }
    }],

    drfreechest: [{
        drresource: {
            family: true,
            basic: [1, 1],
            bonus: [1, 1],
            itemsProb: [0.85, 0.15],
            prob: 0.3
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [2, 1],
            bonus: [2, 2],
            itemsProb: [0.7, 0.3],
            prob: 0.35
        }),

        coins: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.5
        }
    }, {
        drresource: {
            family: true,
            basic: [2, 2],
            bonus: [1, 1],
            itemsProb: [0.85, 0.15],
            prob: 0.35
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [1, 2],
            bonus: [2, 2],
            itemsProb: [0.85, 0.15],
            prob: 0.4
        }),

        coins: {
            basic: [1, 0],
            bonus: [1, 1],
            itemsProb: [0.7, 0.3],
            prob: 0.5
        },

        rubies: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.3
        }
    }, {
        drresource: {
            family: true,
            basic: [0, 2, 2],
            bonus: [2, 2],
            itemsProb: [0.85, 0.10, 0.05],
            prob: 0.4
        },

        heroitem: ChestListTemplates.heroItems("drhero", {
            basic: [1, 1, 1],
            bonus: [2, 2],
            itemsProb: [0.85, 0.10, 0.05],
            prob: 0.45
        }),

        coins: {
            basic: [2, 1, 0],
            bonus: [1, 1],
            itemsProb: [0.6, 0.3, 0.1],
            prob: 0.5
        },

        rubies: {
            basic: [1, 0],
            bonus: [2, 2],
            itemsProb: [0.9, 0.1],
            prob: 0.4
        }
    }],

    drsack: [{
        drfruit: {
            family: true,
            basic: [2, 1],
            itemsProb: [0.99, 0.01],
            bonus: [3, 3],
            prob: 0.35
        },
        energy: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.3
        }
    }, {
        drfruit: {
            family: true,
            basic: [1, 1, 1],
            itemsProb: [0.79, 0.2, 0.01],
            bonus: [4, 4],
            prob: 0.4
        },
        worker: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.3
        },
        energy: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.5
        }
    }, {
        drfruit: {
            family: true,
            basic: [0, 2, 2],
            itemsProb: [0.4, 0.4, 0.2],
            bonus: [0, 2],
            prob: 0.4
        },
        worker: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.5
        },
        coins: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.6
        },
        energy: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.5
        }
    }],

    searesourcechest: [{
        resource: {
            basic: [1],
            bonus: [1, 1],
            prob: 0.15
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [2],
            bonus: [3, 3],
            prob: 0.5
        })
    }, {
        resource: {
            basic: [0, 1],
            bonus: [2, 2],
            itemsProb: [0.85, 0.15],
            prob: 0.2
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [2, 2],
            bonus: [3, 3],
            itemsProb: [0.5, 0.5],
            prob: 0.45
        }),

        worker: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.25
        }
    }, {
        resource: {
            basic: [2, 2],
            bonus: [1, 1],
            itemsProb: [0.5, 0.5],
            prob: 0.5
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [2, 2, 2],
            bonus: [3, 3],
            itemsProb: [0.3, 0.3, 0.4],
            prob: 0.7
        }),

        worker: {
            basic: [1],
            bonus: [2, 2],
            prob: 0.25
        },

        coins: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.25
        }
    }],

    seasack: [{
        seafruit: {
            family: true,
            basic: [2, 1],
            itemsProb: [0.99, 0.01],
            bonus: [3, 3],
            prob: 0.35
        },
        energy: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.3
        }
    }, {
        seafruit: {
            family: true,
            basic: [1, 1, 1],
            itemsProb: [0.79, 0.2, 0.01],
            bonus: [4, 4],
            prob: 0.4
        },
        worker: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.3
        },
        energy: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.5
        }
    }, {
        seafruit: {
            family: true,
            basic: [0, 2, 2],
            itemsProb: [0.4, 0.4, 0.2],
            bonus: [0, 2],
            prob: 0.4
        },
        worker: {
            basic: [0],
            bonus: [1, 1],
            prob: 0.5
        },
        coins: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.6
        },
        energy: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.5
        }
    }],

    seashopchest: [{
        searesource: {
            family: true,
            basic: [0, 1],
            bonus: [1, 1],
            itemsProb: [0.99, 0.01],
            prob: 0.2
        },
        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [0, 3],
            bonus: [1, 1],
            itemsProb: [0.99, 0.01],
            prob: 0.6
        })
    }, {
        searesource: {
            family: true,
            basic: [0, 3],
            bonus: [1, 1],
            itemsProb: [0.75, 0.25],
            prob: 0.4
        },
        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [0, 0, 3],
            bonus: [2, 2],
            itemsProb: [0.45, 0.45, 0.1],
            prob: 0.6
        }),
        worker: {
            basic: [0, 0],
            itemsProb: [0.5, 0.5],
            bonus: [1, 1],
            prob: 0.75
        }
    }, {
        searesource: {
            family: true,
            basic: [0, 0, 3],
            bonus: [2, 2],
            itemsProb: [0.45, 0.45, 0.1],
            prob: 0.5
        },
        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [0, 0, 7],
            bonus: [2, 2],
            itemsProb: [0.34, 0.33, 0.33],
            prob: 0.7
        }),
        worker: {
            basic: [0, 1],
            itemsProb: [0.5, 0.5],
            bonus: [1, 1],
            prob: 0.75
        },
        crystal: {
            basic: [0, 0],
            bonus: [1, 1],
            itemsProb: [0.5, 0.5],
            prob: 0.75
        }
    }],

    seafreechest: [{
        searesource: {
            family: true,
            basic: [1, 1],
            bonus: [3, 3],
            itemsProb: [0.85, 0.15],
            prob: 0.35
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [3, 1],
            bonus: [4, 4],
            itemsProb: [0.7, 0.3],
            prob: 0.5
        }),

        coins: {
            basic: [0],
            bonus: [2, 2],
            prob: 0.5
        }
    }, {
        searesource: {
            family: true,
            basic: [2, 3],
            bonus: [3, 3],
            itemsProb: [0.85, 0.15],
            prob: 0.5
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [3, 5],
            bonus: [5, 5],
            itemsProb: [0.85, 0.15],
            prob: 0.4
        }),

        coins: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.7, 0.3],
            prob: 0.5
        },

        rubies: {
            basic: [0],
            bonus: [3, 3],
            prob: 0.35
        }
    }, {
        searesource: {
            family: true,
            basic: [3, 3, 2],
            bonus: [3, 3],
            itemsProb: [0.85, 0.10, 0.05],
            prob: 0.5
        },

        heroitem: ChestListTemplates.heroItems("seahero", {
            basic: [2, 3, 4],
            bonus: [6, 6],
            itemsProb: [0.85, 0.10, 0.05],
            prob: 0.5
        }),

        coins: {
            basic: [2, 1, 0],
            bonus: [3, 3],
            itemsProb: [0.6, 0.3, 0.1],
            prob: 0.5
        },

        rubies: {
            basic: [1, 0],
            bonus: [3, 3],
            itemsProb: [0.9, 0.1],
            prob: 0.45
        }
    }],

    rpfreechest: [
        {
            rpresource: {
                family: true,
                basic: [-1, 6],
                itemsProb: [0, 1],
                bonus: [0, 2]
            },
            coins: {
                basic: [0],
                bonus: [0, 1],
                prob: 0.1
            }
        }
    ],
    rpshopchest: [
        {
            rpresource: {
                family: true,
                basic: [-1, -1, -1, 6],
                itemsProb: [0, 0, 0, 1],
                bonus: [0, 2]
            },
            coins: {
                basic: [-1, -1, 0],
                bonus: [0, 1],
                prob: 0.1
            },
            rubies: {
                basic: [0],
                bonus: [0, 1],
                prob: 0.01
            }
        }
    ],
    eafreechest: [
        {
            earesource: {
                family: true,
                basic: [-1, 6],
                itemsProb: [0, 1],
                bonus: [0, 2]
            },
            coins: {
                basic: [0],
                bonus: [0, 1],
                prob: 0.1
            }
        }
    ],
    eashopchest: [
        {
            earesource: {
                family: true,
                basic: [-1, -1, -1, 6],
                itemsProb: [0, 0, 0, 1],
                bonus: [0, 2]
            },
            coins: {
                basic: [-1, -1, 0],
                bonus: [0, 1],
                prob: 0.1
            },
            rubies: {
                basic: [0],
                bonus: [0, 1],
                prob: 0.01
            }
        }
    ],
    clsack: [
        {
            clfruit: {
                family: true,
                basic: [8]
            }
        }
    ],
    clpawchest: [
        {
            clpet: {
                basic: [1, 2],
                family: { openPenalty: 0.5 },
                bonus: [1, 1],
                itemsProb: [0.5, 0.5],
                prob: 0.5
            },
            clpetrare: {
                basic: [1],
                family: { openPenalty: 0.5 },
                bonus: [1, 1],
                prob: 0.15
            },
            clpetlegend: {
                basic: [0],
                family: { openPenalty: 0.5 },
                bonus: [1, 1],
                prob: 0.5
            },
            crystal: {
                basic: [0],
                bonus: [1, 1],
                prob: 0.05
            }
        }],
    clpaychest: [
        {
            clpet: {
                basic: [5, 0],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.5, 0.5],
                prob: 0.5
            },
            clpetrare: {
                basic: [3, 0],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.65, 0.35],
                prob: 0.5
            },
            clpetlegend: {
                basic: [1],
                family: true
            },
            crystal: {
                basic: [0],
                bonus: [2, 2],
                prob: 0.3
            }
        },
        {
            clpet: {
                basic: [0, 5],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.5, 0.5],
                prob: 0.5
            },
            clpetrare: {
                basic: [1, 2],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.5, 0.5],
                prob: 0.5
            },
            clpetlegend: {
                basic: [2, 0],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.65, 0.35],
                prob: 0.5
            },
            crystal: {
                basic: [0, 0],
                bonus: [2, 2],
                prob: 0.30
            }
        },
        {
            clpet: {
                basic: [0, 2, 2],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.3, 0.35, 0.35],
                prob: 0.5
            },
            clpetrare: {
                basic: [0, 1, 2],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.3, 0.35, 0.35],
                prob: 0.5
            },
            clpetlegend: {
                basic: [0, 1, 1],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.35, 0.5, 0.15],
                prob: 0.5
            },
            crystal: {
                basic: [1, 0],
                bonus: [3, 3],
                prob: 0.30
            }
        }],
    clsimplechest: [
        {
            clpet: {
                basic: [1, 1],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.5, 0.5],
                prob: 0.5
            },
            clpetrare: {
                basic: [0],
                family: { openPenalty: 0.5 },
                bonus: [1, 1],
                prob: 0.5
            }
        },
        {
            clpet: {
                basic: [0, 0, 1],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.6, 0.3, 0.1],
                prob: 0.5
            },
            clpetrare: {
                basic: [1, 0],
                family: { openPenalty: 0.5 },
                bonus: [1, 1],
                itemsProb: [0.75, 0.25],
                prob: 0.5
            },
            crystal: {
                basic: [0],
                bonus: [1, 1],
                prob: 0.1
            }
        },
        {
            clpet: {
                basic: [0, 2, 1],
                family: { openPenalty: 0.5 },
                bonus: [2, 2],
                itemsProb: [0.65, 0.25, 0.1],
                prob: 0.5
            },
            clpetrare: {
                basic: [1, 1],
                family: true,
                bonus: [2, 2],
                itemsProb: [0.75, 0.25],
                prob: 0.5
            },
            clpetlegend: {
                basic: [2, 0],
                family: true,
                bonus: [1, 1],
                itemsProb: [0.75, 0.25],
                prob: 0.5
            },
            crystal: {
                basic: [0],
                bonus: [1, 1],
                prob: 0.20
            }
        }],
    leafchest: [
        {
            leaf: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0]
        },

        {
            leaf: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1]
        },

        {
            leaf: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2]
        }
    ],
    expredchest: [{
        energy: {
            basic: [4],
            bonus: [0, 1],
            itemsProb: [0.7, 0.3]
        }
    }],
    textilechest: [
        {
            textile: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0]
        },

        {
            textile: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1]
        },

        {
            textile: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2]
        }
    ],
    cardchest: [
        {
            card: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0]
        },

        {
            card: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1]
        },

        {
            card: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2]
        }
    ],
    vampirechest: [
        {
            vampire: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0]
        },

        {
            vampire: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1]
        },

        {
            vampire: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2]
        }
    ],
    waxchest: [
        {
            wax: {
                basic: [1, 0],
                bonus: [2, 2],
                itemsProb: [0.7, 0.3],
                resource: true
            },
            ...SourceChestBonues[0]
        },

        {
            wax: {
                basic: [0, 0, 0],
                bonus: [3, 5],
                itemsProb: [0.25, 0.5, 0.25],
                resource: true
            },
            ...SourceChestBonues[1]
        },

        {
            wax: {
                basic: [0, 0, 0],
                bonus: [7, 9],
                itemsProb: [0.2, 0.4, 0.4],
                resource: true
            },
            ...SourceChestBonues[2]
        }
    ]
};

ChestListPrize.coinsplantchest = [
    { ...ChestListPrize.treasure[0] },

    { ...ChestListPrize.treasure[1] },

    {
        coinstree: {
            basic: [0, 1]
        },
        ...ChestListPrize.treasure[2] 
    }
];

ChestListPrize.rubiesplantchest = [
    { ...ChestListPrize.treasure[0] },

    { ...ChestListPrize.treasure[1] },

    {
        rubiesplant: {
            basic: [1]
        },
        ...ChestListPrize.treasure[2] 
    }
];

ChestListPrize.energyplantchest = [
    { ...ChestListPrize.treasure[0] },

    { ...ChestListPrize.treasure[1] },

    {
        energytree: {
            basic: [0, 1]
        },
        ...ChestListPrize.treasure[2] 
    }
];

ChestListPrize.drwoodchest = ChestListTemplates.extendResourceChest("drwood", ChestListPrize.drresourcechest);
ChestListPrize.drstonechest = ChestListTemplates.extendResourceChest("drstone", ChestListPrize.drresourcechest);
ChestListPrize.drsapphirechest = ChestListTemplates.extendResourceChest("drsapphire", ChestListPrize.drresourcechest);
ChestListPrize.drsledchest = ChestListTemplates.extendResourceChest("drsled", ChestListPrize.drresourcechest);
ChestListPrize.drcastlechest = ChestListTemplates.extendResourceChest("drcastle", ChestListPrize.drresourcechest);

ChestListPrize.drwoodchest = ChestListTemplates.extendResourceChest("drwood", ChestListPrize.drresourcechest);
ChestListPrize.drstonechest = ChestListTemplates.extendResourceChest("drstone", ChestListPrize.drresourcechest);
ChestListPrize.drsapphirechest = ChestListTemplates.extendResourceChest("drsapphire", ChestListPrize.drresourcechest);
ChestListPrize.drsledchest = ChestListTemplates.extendResourceChest("drsled", ChestListPrize.drresourcechest);
ChestListPrize.drcastlechest = ChestListTemplates.extendResourceChest("drcastle", ChestListPrize.drresourcechest);
ChestListPrize.drpurplecrystalchest = ChestListTemplates.extendResourceChest("drpurplecrystal", ChestListPrize.drresourcechest);
ChestListPrize.drbamboochest = ChestListTemplates.extendResourceChest("drbamboo", ChestListPrize.drresourcechest);
ChestListPrize.drfeatherschest = ChestListTemplates.extendResourceChest("drfeathers", ChestListPrize.drresourcechest);

ChestListPrize.seacrabchest = ChestListTemplates.extendResourceChest("seacrab", ChestListPrize.searesourcechest);
ChestListPrize.seafisheschest = ChestListTemplates.extendResourceChest("seafishes", ChestListPrize.searesourcechest);
ChestListPrize.seasharkchest = ChestListTemplates.extendResourceChest("seashark", ChestListPrize.searesourcechest);
ChestListPrize.seaoctopuschest = ChestListTemplates.extendResourceChest("seaoctopus", ChestListPrize.searesourcechest);
ChestListPrize.seahorsechest = ChestListTemplates.extendResourceChest("seahorse", ChestListPrize.searesourcechest);
ChestListPrize.sealochnesschest = ChestListTemplates.extendResourceChest("sealochness", ChestListPrize.searesourcechest);
ChestListPrize.seaturtlechest = ChestListTemplates.extendResourceChest("seaturtle", ChestListPrize.searesourcechest);
ChestListPrize.seashrimpschest = ChestListTemplates.extendResourceChest("seashrimps", ChestListPrize.searesourcechest);

const ChestCreatePrize = {
    treasure: [undefined, { exp: 1 }, { exp: 2 }],
    herochest: [undefined, { exp: 1 }, { exp: 2 }],
    freechest: [undefined, { exp: 1 }, { exp: 2 }],
    dailytaskchest: [undefined, { exp: 1 }, { exp: 2 }],
    coinsplantchest: [undefined, { exp: 1 }, { exp: 2 }],
    rubiesplantchest: [undefined, { exp: 1 }, { exp: 2 }],
    energyplantchest: [undefined, { exp: 1 }, { exp: 2 }],
    woodchest: [undefined, { exp: 1 }, { exp: 3 }],
    resourcechest: [undefined, { exp: 5 }, { exp: 15 }],
    sacks: [undefined, { exp: 1 }, { exp: 2 }]
};

const ChestEnergyPrize = {
    treasure: [4, 12, 36],
    freechest: [1, 3, 9],
    herochest: [3, 9, 27],
    dailytaskchest: [15, 30, 60],
    coinsplantchest: [3, 9, 27],
    rubiesplantchest: [3, 9, 27],
    energyplantchest: [3, 9, 27],
    resourcechest: [3, 9, 27],
    sacks: [1, 3, 9]
};

if (typeof cc === "undefined") {
    module.exports = {
        ChestListPrize,
        ChestCreatePrize,
        ChestEnergyPrize
    };
}
